<template lang="pug">
    .logs
        .log(v-for='log in logs')
            .log__time(v-html='log.timestamp.toDate().toLocaleString()')
            .log__name(v-html='log.username')
            .log__miss(v-html='missdata.find(miss => miss.id === Number(log.missId)).name')
            .log__network(v-html='log.network')
    //- .participants
    //-     .girl(v-for='girl in missdata')
    //-         .girl__name {{girl.name}}
    //-         .girl__likes-total Всего лайков: {{girl.likes}}
    //-         .girl__likes
                //- .like(v-for='like in likes', v-if='Number(like.id) === Number(girl.id)')
                //-     span {{like.network}} |
                //-     span {{like.username}}


</template>

<script>
import {mapState} from 'vuex';
export default {
    name: 'PartisipantData',

    data() {
        return {
            missdata: this.$store.state.participants,
            logs: false
        };
    },

    computed: mapState(['logsData']),

    watch: {
        logsData(res) {
            this.logs = [...res];
            this.sortArr();
        }
    },

    mounted() {
        this.$store.commit('getLogs');
    },

    methods: {
        sortArr() {
            // this.missdata.sort((a, b) => {
            //     if (a.likes < b.likes) {
            //         return 1;
            //     }

            //     if (a.likes > b.likes) {
            //         return -1;
            //     }

            //     return 0;
            // });
            this.logs.sort((a, b) => {
                return b.timestamp.toDate() - a.timestamp.toDate();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
.logs {
    padding: 15vw 10vw;
    display: flex;
    flex-direction: column;
    width: 100%;

    .log {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid black;
        margin: 5px 0;
        padding-bottom: 5px;
        width: 100%;

        &__time,
        &__name,
        &__network,
        &__miss {
            margin: 0 10px;
        }

        &__name {
            flex: 1;
        }

        &__network {
            min-width: 9vw;
            text-align: right;
        }
    }
}
</style>
